export { createMagicProxy, getRaw } from './proxy.js';
